import { createElement } from 'src/app/core/helpers/dom';
import { translate } from 'src/app/project/features/translate/translate';
import { GET_GROUPING } from '../../../columns/grouping.store';
import { GET_TABLE } from '../../../table.ui.store';
import Table from '../../table/Table';
import { getSelectElementWidthPx } from '../../table/utils/select-element-width';
import { createFooterCellElement } from './create-footer--cell-element';

export function createFooterTotalPointsElement(): HTMLElement {
  const table = GET_TABLE();
  const grouping = GET_GROUPING();

  const totalPointsText: string = getTotalPointsText(table);

  const totalPointsElement = createElement<HTMLElement>('span', {
    attrs: {
      class: 'table__footer__totalPoints',
      id: 'sortingElement',
    },
    children: [totalPointsText],
  });

  if (table.tableFooter) {
    table.tableFooter.totalPointsElement = totalPointsElement;
  }

  const className = 'table__select table__footer__select';

  return createFooterCellElement({
    className,
    center: true,
    width: getSelectElementWidthPx(grouping.length),
    child: totalPointsElement,
  });
}

function getTotalPointsText(table: Table): string {
  const apiKey = table?.pointSearchService?.getAPIKey();

  const totalPoints = table?.pointSearchService.getTotalCount(apiKey) || 0;

  const pointTranslation = translate(totalPoints === 1 ? 'point_lowercase' : 'points_lowercase');
  return `${translate('showing')} ${totalPoints} ${pointTranslation}`;
}
